import { ListboxInput } from '@reach/listbox';
import PropTypes from 'prop-types';
import * as React from 'react';
import { DEPRECATED_PROP_MESSAGES } from '../../../react/constants/messages.js';
import { useComponentStylesLoaded } from '../../../react/hooks/use-component-styles-loaded.js';
import { LegacyListboxInternalContextProvider } from './legacy.listbox.context.js';
import { deprecatedProp } from '../../../react/components/core/deprecated-prop.js';
import { renderWithRef } from '../../../react/components/core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../../../react/components/head/stylesheets.component.js';
import { useFormFieldProps } from '../../../react/components/form/form.context.js';
import { useId } from '../../../react/hooks/use-id.js';
import { filterProps } from '../../../react/components/core/core.utils.js';
import { processStyleProps } from '../../../core/utilities/swan-style.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const propTypes = {
    /**
   * @deprecated use `size` prop instead
   */ sizeVariant: deprecatedProp(PropTypes.oneOf([
        'standard',
        'mini'
    ]), DEPRECATED_PROP_MESSAGES.size),
    /**
   * Select Size
   */ size: PropTypes.oneOf([
        'standard',
        'mini'
    ]),
    /**
   * Specify the skin type
   */ skin: PropTypes.oneOf([
        'standard',
        'link',
        'error'
    ]),
    /**
   * Decide whether the Listbox should expand to fill the entire width of its container.
   */ fullWidth: PropTypes.bool
};
const propKeysToRemove = Object.keys(propTypes);
const LegacyListbox = renderWithRef('LegacyListbox', propTypes, (props, ref)=>{
    useComponentStylesLoaded('LegacyListbox', SWAN_STYLE_KEY_MAP.legacyListbox);
    const formProps = useFormFieldProps(useId(props.id));
    const { as, component, children, className, sizeVariant = 'standard', size = sizeVariant, skin, fullWidth } = props;
    const classes = new Set([
        'swan-legacy-listbox-input'
    ]);
    if (size === 'mini') classes.add('swan-legacy-listbox-mini');
    if (skin === 'error' || (formProps === null || formProps === void 0 ? void 0 : formProps['aria-invalid'])) classes.add('swan-legacy-listbox-skin-error');
    if (skin === 'link') classes.add('swan-legacy-listbox-skin-link');
    if (fullWidth) classes.add('swan-legacy-listbox-full-width');
    if (className) classes.add(className);
    const filteredProps = filterProps(props, propKeysToRemove, processStyleProps(props, classes));
    return /*#__PURE__*/ React.createElement(LegacyListboxInternalContextProvider, null, /*#__PURE__*/ React.createElement(ListboxInput, _object_spread_props(_object_spread({
        as: as || component || 'div'
    }, filteredProps, formProps), {
        ref: ref
    }), children));
});
LegacyListbox.defaultProps = {
    skin: 'standard',
    sizeVariant: 'standard'
};

export { LegacyListbox };
